import React, {useEffect, useState} from "react";
import {IRecurso} from "@models/recurso/IRecurso.ts";
import {IRecursoMembro} from "@models/recurso/IRecursoMembro.ts";
import {GetRecursoMembros, RemoveRecursoMembro} from "@localization/siteMap/endpoints/_RecursosEndpoints.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {
	Button,
	Grid,
	IconButton,
	TableBody,
	Paper,
	Table,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from "@mui/material";
import {RecursoMembroInformacaoRow,} from "@components/recurso/membros/RecursoMembroInformacao.tsx";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {AddOutlined, DeleteOutlined, FilterAlt} from "@mui/icons-material";
import {AddRecursoMembroComponent} from "@components/recurso/membros/AddRecursoMembroComponent.tsx";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {IRecursoMembroGetDto} from "@models/recurso/RecursoMembroDto";
import {useApi} from "@contexts/hooks/api/useApi.ts";

interface RrecursoMembrosProps {
	filtros?: IRecursoMembroGetDto;
	recurso?: IRecurso;
}

export const RecursoMembrosPage: React.FC<RrecursoMembrosProps> = (props) => {
	const {Get} = useApi();
	const {createAlertFromResponse, addPopUp, closePopUp} = useAlert();
	const [filtros] = useState<IRecursoMembroGetDto>(props.filtros || {});
	const [membros, setMembros] = useState<IRecursoMembro[]>([]);
	const [pagination, setPagination] = useState<IPagination>({page: 0, pageSize: 10});
	const [loading, setLoading] = useState(false);

	useEffect(() => {
			if (pagination.page == 0) {
				setPagination({...pagination, page: 1});
				return;
			}

			setPagination(prev => ({...prev, loading: true}))
			GetRecursoMembros({...filtros}, pagination).then(x => {
				if (x.status == "Success") {
					setMembros(x.items);
					setPagination(prev => ({...prev, ...x.pagination}));
				}
			}).finally(() => {
				setPagination(prev => ({...prev, loading: false, ignoreCache: false}))
			})

		},
		[pagination.page, pagination.ignoreCache == true]);


	const removeHandler = (membro: IRecursoMembro) => {
		setLoading(true);
		Get(RemoveRecursoMembro([{
			idMembro: membro.usuarioId,
			idRecurso: membro.recursoId,
			funcaoRecurso: membro.funcaoRecursoId,
		}]))
			.then(x => {
				createAlertFromResponse(x);
				if (x.status == "Success") {
					setPagination({...pagination, page: 0});
				}
			}).finally(() => {
			setLoading(false);
		});
	};

	return (
		<DefaultContainer permissaoNecessaria={['CriarRecurso', 'EditarRecurso']}
		                  component={Paper}
		                  UpperComponent={<Grid size={12}>
			                  <Grid container justifyContent={'space-between'}>
				                  <Grid>
					                  {props.recurso && <Button variant={'outlined'} loading={loading} onClick={() => {
						                  if (props.recurso)
							                  addPopUp({
								                  title: 'Incluir membro a recurso',
								                  content: <AddRecursoMembroComponent
									                  recurso={props.recurso}
									                  onCreate={(_v) => {
										                  setPagination({
											                  ...pagination,
											                  page: 0,
										                  });
										                  closePopUp();
									                  }}/>, size: "lg"
							                  });
					                  }}
					                                            endIcon={<AddOutlined/>}>Adicionar Membro</Button>}
				                  </Grid>
				                  <Grid>
					                  <IconButton>
						                  <FilterAlt/>
					                  </IconButton>
				                  </Grid>
			                  </Grid>
		                  </Grid>}
		                  pageProps={{pagination, setPagination}}>
			<Grid size={12}>
				<TableContainer>
					<Table size={'small'} stickyHeader>
						<TableHead>
							<TableRow>
								<TableCell>Id</TableCell>
								<TableCell>Recurso</TableCell>
								<TableCell>Usuario</TableCell>
								<TableCell>Função</TableCell>
								<TableCell align={'right'}>Mais</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{membros.map(membro => (
								<RecursoMembroInformacaoRow value={membro}
								                            key={`${membro.recursoId}:${membro.usuarioId}:${membro.funcaoRecursoId}`}
								                            EndComponent={(e) => {
									                            return <IconButton size={'small'}
									                                               color={'error'}
									                                               onClick={() => {
										                                               removeHandler(e);
									                                               }}
									                            ><DeleteOutlined/></IconButton>;
								                            }}/>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Grid>
		</DefaultContainer>
	);
};